import React, { useMemo } from 'react';

import { useEnrollmentDomainParams } from 'global/hooks/useEnrollmentDomainParams';
import EmployerFormsPageStore, { EmployerFormsPageStoreContext } from 'store/pages/enrollment/employer-forms/pageStore';
import EmployerFormsContent from 'components/enrollment/employer-forms';

/** DISCLAIMER: This page will be used after whole enrollment flow is reworked into the new design approach */
const EmployerFormsPageV2: React.FC = () => {
  const { groupId, periodId } = useEnrollmentDomainParams();
  const pageStore = useMemo(() => new EmployerFormsPageStore({ groupId, periodId }), [groupId, periodId]);

  return (
    <EmployerFormsPageStoreContext.Provider value={pageStore}>
      <EmployerFormsContent />
    </EmployerFormsPageStoreContext.Provider>
  );
};

export default EmployerFormsPageV2;
